
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1636"}},[_c('path',{attrs:{"data-name":"Rectangle 2365","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1635"}},[_c('path',{attrs:{"data-name":"Path 1001","d":"M16.414 14.875l2.293-2.293a1 1 0 10-1.414-1.415L15 13.46l-2.293-2.293a1 1 0 10-1.414 1.415l2.293 2.293-2.293 2.292a1 1 0 101.414 1.415L15 16.289l2.293 2.293a1 1 0 001.414-1.415z"}}),_c('path',{attrs:{"data-name":"Path 1002","d":"M15 3.125a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4z"}}),_c('path',{attrs:{"data-name":"Rectangle 2366","fill":"#adadad","d":"M1 4.125h8v2H1z"}}),_c('path',{attrs:{"data-name":"Rectangle 2367","fill":"#adadad","d":"M1 13.875h8v2H1z"}})])])])
          )
        }
      }
    